import React from "react";

import { useTranslation } from "react-i18next";

import { OWNER } from "../../constants/roles";
import useAbility from "../../hooks/useAbility";
import Input from "../form/Input";

function EncodingNotifications(): React.JSX.Element {
  const { t } = useTranslation("admin-profile");

  const { hasRole } = useAbility();

  const isOwner = hasRole([OWNER]);

  return (
    <div className="text-muted-foreground my-6 flex flex-col gap-6">
      <div className="text-[1.171875rem]">{t("encodingNotifications")}</div>
      <div className="flex flex-col">
        <Input
          isCompact
          isNoWrap
          isReversed
          label={t("mailNotifications")}
          name="mailNotifications"
          size="sm"
          type="switch"
        />
        {isOwner ? (
          <Input
            isCompact
            isNoWrap
            isReversed
            label={t("zapierNotifications")}
            name="zapierNotifications"
            size="sm"
            type="switch"
          />
        ) : null}
        <Input
          isCompact
          isNoWrap
          isReversed
          label={t("inAppNotifications")}
          name="inAppNotifications"
          size="sm"
          type="switch"
        />
      </div>
    </div>
  );
}

export default EncodingNotifications;
